import { dispatch } from "@wordpress/data";
import type { Intent } from "./auth-state-machine";
import { authStore } from "./auth-store";

type CopyOverrides = Partial<{
	modalTitle: string;
	submitText: string;
	successTitle: string;
	successMessage: string;
	accountCreationNote: string;
}>;

export type OpenAuthModalOpts = {
	intent: Intent;
	prefillEmail?: string;
	copy?: CopyOverrides;
};

export function openAuthModal(opts: OpenAuthModalOpts): void {
	dispatch(authStore).openModal(opts);
}

export function closeAuthModal(): void {
	dispatch(authStore).closeModal();
}
